import { KeyboardEvent, MouseEvent, useCallback, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_KSK2011_R01 } from "./Content_KSK2011_R01"
import { KSK2011_R01DetailDto, KSK2011_R01Dto } from "./Dto_KSK2011_R01"
import { Modal_KSK2011_R01 } from "./Modal_KSK2011_R01"
import { SearchSection_KSK2011_R01 } from "./SearchSection_KSK2011_R01"
import { useKSK2011_R01Store } from "./Store_KSK2011_R01"
import { Table_KSK2011_R01 } from "./Table_KSK2011_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_KSK2011_R01 = () => {
	const { 
		KSK2011_R01List,
		insertKSK2011_R01List,
		modalVisible,
		initData,
	} = useKSK2011_R01Store();
	const { setMessage } = useUiuxStore();
	
	const gridRef = useRef<AgGridReact<KSK2011_R01Dto> | null>(null);
	const detailGridRef = useRef<AgGridReact<KSK2011_R01DetailDto> | null>(null);
	

	const {
		fetchData,
		fetchWorkInfoData,
		fetchDetailList,
		defaultKSK2011_R01Row,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		buttonDisabled,
		handleWorkSaveClick,
		handleWorkDeleteClick,
	} = Content_KSK2011_R01({
		gridRef,
		detailGridRef,
		setMessage,
		
	});

    const [clickable, setClickable] = useState(true);

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		const defaultRow = defaultKSK2011_R01Row();
		InsertRowHandler({
			event: e,
			dataList: KSK2011_R01List,
			rowData: {...defaultRow, valueIndex: -1},
			insertRow: insertKSK2011_R01List,
			defaultRowData: defaultRow,
			setClickable
		});
	}, [KSK2011_R01List, insertKSK2011_R01List, defaultKSK2011_R01Row, setClickable]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initData}
		/>
		
		<SearchSection_KSK2011_R01
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<Table_KSK2011_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					fetchWorkInfoData={fetchWorkInfoData}
					fetchDetailList={fetchDetailList}
				/>
			</div>
		</div>
		{modalVisible && 
			<Modal_KSK2011_R01 
				handleWorkSaveClick={handleWorkSaveClick}
				handleWorkDeleteClick={handleWorkDeleteClick}
				detailGridRef={detailGridRef}
			/>
		}
	</div>
}
